import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux'
import { compose } from 'recompose';

import { withStyles } from '@material-ui/core';
import LibrarySectionList from '../LibrarySectionList'
import TrendingHashtag from './TrendingHashtag'
import { showSnackbar } from '../../../../../actions/appActions';
import { librarySections } from '../../../../../utils/library/librarySections';
import NoItemsPlaceholder from '../NoItemsPlaceholder/NoItemsPlaceholder';

const HEIGHT_TWO_ROW = 677 + 48
const HEIGHT_SINGLE_ROW = HEIGHT_TWO_ROW - 320
const HEIGHT_NO_ITEMS = 150

const styles = theme => ({
    trendingHashtagsContainer: {
        height: HEIGHT_TWO_ROW,
        width: 1286,
        backgroundColor: '#f5f5f5',
        marginTop: 48,
        marginRight: 'auto',
        marginLeft: 'auto',
    },
    headerSection: {
        height: 70,
        display: 'flex',
        flexDirection: 'row',
    },
    titles: {
        flexDirection: 'column',
        marginRight: 'auto'
    },
    title: {
        fontFamily: 'Rubik',
        fontSize: 32,
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: 'normal',
        color: '#21212d',
    },
    subtitle: {
        fontFamily: 'Rubik',
        fontSize: 16,
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.75,
        letterSpacing: 'normal',
        color: '#a3a3a3',
    },
    controlButtons: {
        flexDirection: 'column',
        alignSelf: 'center',
        border: 'solid 2px #e0e0e0',
        borderRadius: 4,
        width: 84,
        height: 38,
    },
    buttonAll: {
        flexDirection: 'column',
        marginRight: 12,
        marginLeft: 'auto',
    },
    hashtags: {
        marginTop: (46 + 14) * -1,
        justifyContent: 'flex-start',
    },
    disableIcon:{
        fill: theme.newUI.color.gray
    },
    activeIcon:{
        cursor: 'pointer',
        fill: theme.newUI.color.commonBlack
    },
    leftButton: {
        width: 42,
        height: 38,
        background: 'none',
        border: 'none',
    },
    rightButton: {
        width: 42,
        height: 38,
        borderRadius: 4,
        background: 'none',
        border: 'none',
        borderLeft: 'solid 0.5px #e0e0e0',
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0,
    },
    controlWrap: {
        width: 1286,
        top: 0,
        position: 'absolute',
        display: 'flex',
        justifyContent: 'flex-end'
    },
    listContainer: {
        width: 1286,
        height: HEIGHT_TWO_ROW,
        alignItems: 'end'
    },
    listContainerRow: {
        width: 1286,
        height: HEIGHT_SINGLE_ROW,
        alignItems: 'end'
    },
    cardsContainer: {
        justifyContent: 'flex-start',
        position: 'absolute',
        top: 60,
        gridTemplateColumns: 'auto auto auto auto auto auto',
        display: 'grid',
        gridTemplateRows: '320px 310px',
        gridAutoColumns: '216px',
        gridAutoFlow: 'column'
    },
    cardsContainerR: {
        gridAutoFlow: 'inherit'
    },
    cardsContainerRow: {
        position: 'absolute',
        top: 60,
        gridTemplateColumns: 'none',
        display: 'grid',
        gridTemplateRows: '320px',
        gridAutoColumns: '216px',
        gridAutoFlow: 'column'
    },
});

const SCREEN_ITEMS = 12

const mapTrends = (trends) => [...trends.map(trend => ({
    meta: trend,
    title: `#${trend.key}`,
    items: trend.value,
    backgroundImage: '/resources/hashtag.jpeg'
}))].sort((a,b) => b.items - a.items)

const TrendingHashtags = (props) => {
    const {classes, trends} = props
    const [hashtags, setHashtags] = useState([])
    const [isLoading, setIsLoading] = useState(false)

    useEffect(() => {
        setHashtags(mapTrends(trends ?? []))
    }, [trends])

    const Header = (
        <div data-intrcm-id="TrendingHashtags_65za0zzk" className={classes.title}>{librarySections().trendingHashtags.title}</div>
    )
    const SubHeader = (
        <div data-intrcm-id="TrendingHashtags_roj3d9tw" className={classes.subtitle}>{librarySections().trendingHashtags.subtitle}</div>
    )

    const subscribe = (tagInfo, goToHashtag) => {
        if(isLoading) return
        const { userSettingsService, dispatch } = props;
        setIsLoading(true)
        dispatch(showSnackbar('subscribing...'));
        userSettingsService
            .subscribe(tagInfo)
            .then((_) => {
                userSettingsService.getUserData().then((userData) => {
                    dispatch(showSnackbar('Subscribed successfully!'));
                    dispatch({
                        type: 'USER_DATA_LOAD', data: {
                            ...userData
                        }
                    });
                    setIsLoading(false)
                    goToHashtag()
                })
            });
    }

    const controlStyles = {
        controlWrap: classes.controlWrap,
        controlButtons: classes.controlButtons,
        leftButton: classes.leftButton,
        rightButton: classes.rightButton,
        activeIcon: classes.activeIcon,
        disableIcon: classes.disableIcon,
        arrowBg: 'transparent'
    }

        return (
            <div data-intrcm-id="TrendingHashtags_g3cc5xgh" style={{height: hashtags.length === 0 ? HEIGHT_NO_ITEMS : hashtags.length <= 6 ? HEIGHT_SINGLE_ROW : HEIGHT_TWO_ROW}} className={classes.trendingHashtagsContainer}>
              <div data-intrcm-id="TrendingHashtags_gbzz8wop" className={classes.headerSection} >
                <div data-intrcm-id="TrendingHashtags_vunivgwz" className={classes.titles}>
                    {Header}
                    {SubHeader}
                </div>
              </div>
              {hashtags.length === 0 &&
                <NoItemsPlaceholder placeholder={"No hashtags available"} />
              }
              <div data-intrcm-id="TrendingHashtags_t4o7cdvu" className={classes.hashtags}>
              {hashtags.length > 0 &&
                <LibrarySectionList screenSize={1} listContainerStyle={hashtags.length <= 6 ? classes.listContainerRow : classes.listContainer} cardsContainerStyle={hashtags.length <= 6 ? classes.cardsContainerRow : hashtags.length <= 12 ? [classes.cardsContainer, classes.cardsContainerR].join(" ") : classes.cardsContainer} controlStyles={controlStyles} >
                  {hashtags.map((hashtag, i) => (
                      <TrendingHashtag key={i} hashtag={hashtag} subscribe={subscribe} />
                  ))}
                </LibrarySectionList>
              }
              </div>
          </div>
        )
}

const mapStateToProps = (state) => ({
    trends: state.globalData.trends,
    userSettingsService: state.services.userSettingsService,
    userData: state.userData,
})


const mapDispatchToProps = dispatch => ({ dispatch })

export default compose(withStyles(styles, {withTheme: true}),
    connect(mapStateToProps, mapDispatchToProps))(TrendingHashtags);